module.exports = __webpack_public_path__ + "img/cancel.4b560d0c.svg";